export default __webpack_public_path__ + "static/media/koho_close white.ae7547fc.svg";